import React, {
	KeyboardEvent,
	MouseEvent,
	useEffect,
	useRef,
	useState,
} from 'react';
import { ISearchInputProps, SearchInput } from './SearchInput';

export interface ISearchProps extends Partial<ISearchInputProps> {
	onUpdateQuery: (query: string) => void;
	placeholderAsLabel?: boolean;
}

export const Search: React.FC<ISearchProps> = ({
	onUpdateQuery,
	onClickSearch,
	onClickClear,
	onKeyUp,
	...rest
}) => {
	const [query, setQuery] = useState<string>('');
	const inputRef = useRef<HTMLInputElement>(null);

	const updateQuery = () => {
		if (inputRef.current) {
			const newQuery = inputRef.current.value;
			setQuery(newQuery);
		}
	};

	const onClickClearHandler = (e: MouseEvent) => {
		if (inputRef.current) {
			inputRef.current.value = '';
			updateQuery();

			if (onClickClear) {
				onClickClear(e);
			}
		}
	};

	const onClickSearchHandler = (e: MouseEvent) => {
		updateQuery();

		if (onClickSearch) {
			onClickSearch(e);
		}
	};

	const onKeyUpHandler = (e: KeyboardEvent<HTMLInputElement>) => {
		updateQuery();

		if (onKeyUp) {
			onKeyUp(e);
		}

		if (e.key === 'Enter' && inputRef.current) {
			inputRef.current.blur();
		}
	};

	useEffect(() => {
		onUpdateQuery(query);
	}, [query, onUpdateQuery]);

	const showClearIcon = query !== '';

	return (
		<SearchInput
			onClickSearch={onClickSearchHandler}
			onClickClear={onClickClearHandler}
			showClearIcon={showClearIcon}
			onKeyUp={onKeyUpHandler}
			ref={inputRef}
			{...rest}
		/>
	);
};
